import { HttpMethod, ParamsContainer, defineHandler } from "@tsp/api";

export type GetAttachmentLinkRequestParams = {
  entityUuid: string;
  entityType: string;
};

export type GetAttachmentLinkResponseResult = {
  temporaryLink: string;
};

const getAttachmentLink = defineHandler<GetAttachmentLinkRequestParams, GetAttachmentLinkResponseResult>({
  path: "/getAttachmentLink",
  method: HttpMethod.POST,
  params: ParamsContainer.Body,
});

export type GetCommunicationLinkRequestParams = {
  entityUuid: string;
  entityType: string;
};

export type GetCommunicationLinkResponseResult = {
  permalink: string;
};

const getCommunicationLink = defineHandler<GetCommunicationLinkRequestParams, GetCommunicationLinkResponseResult>({
  path: "/getCommunicationLink",
  method: HttpMethod.POST,
  params: ParamsContainer.Body,
});

export const externalResourcesApi = {
  getAttachmentLink,
  getCommunicationLink,
};
